import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'IDENTITY',
  entryPoint: '/entities',
  collectionName: 'entities',
  querySearchListing: [
    ['first_name', 'last_name', 'primary_email'],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Identiy created',
  successMessageUpdate: 'Identiy updated',
  successMessageDelete: 'Identiy deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/entity/triggers.js